module.exports = __webpack_public_path__ + "static/media/rocket-tail.png";